<div class="guesses pt-2">
    <app-guess *ngFor="let guess of guesses$ | async" [guess]="guess"></app-guess>
    <app-input></app-input>
</div>
